/* import __COLOCATED_TEMPLATE__ from './sq-custom-report-print-table.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { classNames, tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
function indentationSpaces(indentation) {
  return htmlSafe('&emsp;'.repeat(indentation));
}

/**
## Sq Custom Report Print Table

Takes the same columns and content as sq-super-table, but displays the table in a printer-friendly manner.
It will only be shown while the page is being printed.

### Example

```handlebars

{{sq-custom-report-print-table content=content
                               columns=columns}}
```

### Example

```handlebars

{{#sq-custom-report-print-table content=content
                                columns=columns as |row column|}}
    <strong>{{get row column.cellContentProperty}}</strong>
{{/sq-custom-report-print-table}}

```

### Parameters
@param {Column[]} columns - The columns for the table, as defined in sq-super-table
@param {CustomReportTableRow[]} content - The content for the rows of the table, as defined in sq-super-table
@param {Boolean} [hasFooter=true] - If true, a footer will be displayed.
*/
let SqCustomReportPrintTable = (_dec = classNames('show-when-print', 'l-reports--table'), _dec2 = tagName('table'), _dec3 = computed('content.@each.{isNested,indentation}', 'columns.@each.{cellContentFunction,cellContentProperty,typeAlign}'), _dec4 = computed('columns.@each.{headerCellTitle,typeAlign}'), _dec5 = computed('columns.@each.{footerValue,typeAlign}'), _dec(_class = _dec2(_class = (_class2 = class SqCustomReportPrintTable extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, 'data-test-custom-report-print-table', true);
    _defineProperty(this, "columns", null);
    _defineProperty(this, "content", null);
    _defineProperty(this, "hasFooter", true);
  }
  get rows() {
    return this.content.map(row => {
      return {
        rowClass: row.get('isNested') ? 'super-table-row--is-nested' : undefined,
        cells: this.columns.map((column, index) => {
          return {
            indent: index === 0 ? indentationSpaces(row.get('indentation')) : '',
            value: column.getCellContent(row),
            columnClass: column.get('typeAlign'),
            row,
            column
          };
        })
      };
    });
  }
  get headers() {
    return this.columns.map(column => {
      return {
        name: column.get('headerCellTitle'),
        columnClass: column.get('typeAlign')
      };
    });
  }
  get footerCells() {
    return this.columns.map(column => {
      return {
        value: column.get('footerValue'),
        columnClass: column.get('typeAlign')
      };
    });
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "rows", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "rows"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "headers", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "headers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "footerCells", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "footerCells"), _class2.prototype)), _class2)) || _class) || _class);
export { SqCustomReportPrintTable as default };